import { useMemo } from 'react';
import PropTypes from 'prop-types';

import PrintInventoryStockLabelsButton from '#/modules/imsMgmt/inventoryStock/components/PrintInventoryStockLabelsButton';

import { flattenInventoryStockIds } from '../columns/stockReceiptLineColumns';

/**
 * 入庫明細列印標籤：flatten lines 後交給 PrintInventoryStockLabelsButton。
 * 預設左鈕為全部列印。
 */
const StockReceiptPrintLabelButton = ({
  lines = [],
  selectedInventoryStockIds = [],
  printMutation = null,
  defaultItemId = 'all',
}) => {
  const allInventoryStockIds = useMemo(
    () => flattenInventoryStockIds(lines),
    [lines],
  );

  return (
    <PrintInventoryStockLabelsButton
      selectedInventoryStockIds={selectedInventoryStockIds}
      allInventoryStockIds={allInventoryStockIds}
      printMutation={printMutation}
      defaultItemId={defaultItemId}
    />
  );
};

StockReceiptPrintLabelButton.propTypes = {
  lines: PropTypes.arrayOf(PropTypes.object),
  selectedInventoryStockIds: PropTypes.arrayOf(PropTypes.string),
  printMutation: PropTypes.object,
  defaultItemId: PropTypes.string,
};

export default StockReceiptPrintLabelButton;
